(function defineProductModel() {
  // DeferredMedia comes from deferred-media.js, which every file rendering <product-model>
  // loads. Scripts the theme editor inserts can run in any order, so take it from the
  // registry and wait for it rather than assume it ran first. Pages that load this file only
  // for window.ProductModel (the main product gallery renders no <product-model>) skip
  // deferred-media.js, and the element simply stays undefined there.
  const DeferredMedia = customElements.get('deferred-media');
  if (!DeferredMedia) {
    customElements.whenDefined('deferred-media').then(defineProductModel);
    return;
  }

  if (!customElements.get('product-model')) {
    customElements.define(
      'product-model',
      class ProductModel extends DeferredMedia {
        constructor() {
          super();
        }

        loadContent() {
          super.loadContent();

          Shopify.loadFeatures([
            {
              name: 'model-viewer-ui',
              version: '1.0',
              onLoad: this.setupModelViewerUI.bind(this),
            },
          ]);
        }

        setupModelViewerUI(errors) {
          if (errors) return;

          this.modelViewerUI = new Shopify.ModelViewerUI(
            this.querySelector('model-viewer'),
          );
        }
      },
    );
  }
})();

window.ProductModel = {
  loadShopifyXR() {
    // Shopify XR only wires up "View in your space" buttons ([data-shopify-xr]). Pages whose
    // gallery uses the Project Unity 3D viewer render none, and the library also brings
    // Bugsnag, whose click listener added up to 76 ms to taps on a throttled phone (INP).
    if (!document.querySelector('[data-shopify-xr]')) return;
    Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXR.bind(this),
      },
    ]);
  },

  setupShopifyXR(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', () =>
        this.setupShopifyXR(),
      );
      return;
    }

    document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
      window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
      modelJSON.remove();
    });
    window.ShopifyXR.setupXRElements();
  },
};

window.addEventListener('DOMContentLoaded', () => {
  if (window.ProductModel) window.ProductModel.loadShopifyXR();
});
